import { notification } from "antd";
import { ApolloError } from "apollo-client";
import { action, makeAutoObservable } from "mobx";
import { Api } from "../../common/Api";
import { VolunteersStore } from "./VolunteersStore";

export class VolunteerCancelStore {
  store: VolunteersStore;
  showDlg = false;
  loading = false;
  saving = false;
  id;
  schedule = [];
  model: any;

  constructor(store: VolunteersStore) {
    makeAutoObservable(this, {
      store: false,
    });
    this.store = store;
  }

  @action show(id, schedule) {
    this.id = id;
    this.schedule = schedule || [];
    this.showDlg = true;
  }
  @action close() {
    this.showDlg = false;
  }

  @action save(date) {
    this.saving = true;
    return Api.volunteer
      .cancelVolunteer(this.id, date)
      .then((res) => {
        notification.success({ message: "Success!" });
        setTimeout(() => {
          this.store.refresh();
        }, 3000);
        this.showDlg = false;
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.saving = false));
  }
}
